import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import { DatasourceManagementRouter } from './pages/DatasourceManagementRouter';
import { DatasourceManagementState } from './state';
import { InitializationState, initialize } from './state/appSlice';
import { persistor, DatasourceDispatch } from './state/store';

// Init/permission gate for the data-source section. The consolidated admin
// shell (apps/admin/src/index.tsx) provides Provider/FlagProvider/PersistGate/
// BrowserRouter/Layout, so this section no longer wraps those itself.
const App = () => {
  const dispatch = useDispatch<DatasourceDispatch>();

  const { initializing, initialized, initError } = useSelector<
    DatasourceManagementState,
    InitializationState
  >(state => state.appDataSource);
  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);

  if (initError) {
    return <ErrorPage persistor={persistor} />;
  }
  if (initializing) {
    return <AppLoading />;
  }
  if (initialized) {
    return (
      <AppInnerWrapper>
        <DatasourceManagementRouter />
      </AppInnerWrapper>
    );
  }
  return <ErrorPage persistor={persistor} />;
};

export default App;
